import React, { useEffect, useState } from 'react';
import {
    GoogleMap,
    useJsApiLoader,
    Marker,
    InfoWindow,
    DirectionsService,
    DirectionsRenderer
} from '@react-google-maps/api';
import axios from 'axios';

const containerStyle = {
    width: '100%',
    height: '100vh'
};
const initialCenter = {
    lat: 29.94529121237958,
    lng: 30.936793575195466
};
function Surroundings() {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyCxCEqYdnFLSQKQg98Swzs4hL7rpYXgpHk' // Replace with your API key
    });
    const [map, setMap] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [directions, setDirections] = useState(null);
    const [infoWindowContent, setInfoWindowContent] = useState('');
    const [infoWindowPosition, setInfoWindowPosition] = useState(null);
    const [markerShow, setMarkerShow] = useState(true);
    const [isActive, setIsActive] = useState(false);
    const [filterPannel, setFilterPannel] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [locationCatogory, setLocationCatogory] = useState(null);
    const [catogoryName, setCatogoryName] = useState(null);
    const [catogoryTime, setCatogoryTime] = useState(null);
    const [catogoryDistance, setCatogoryDistance] = useState(null);
    const [catogoryAddress, setCatogoryAddress] = useState(null);
    const [catogoryImage, setCatogoryImage] = useState('');
    const [showAllActive, setShowAllActive] = useState(true);
    const [hideAllActive, setHideAllActive] = useState(false);
    const [showAllMarkers, setShowAllMarkers] = useState(true); // Track if all markers should be shown
    const [filteredCategory, setFilteredCategory] = useState(null); // Track the selected category
    const categoryIcons = {
        // PublicTransport: '/assets/images/icons/public_transport.svg',
        Education: '/assets/images/icons/education.svg',
        Hospital: '/assets/images/icons/hospital.svg',
        Club: '/assets/images/icons/club.svg',
        Mall: '/assets/images/icons/mall.svg',
        Hotel: '/assets/images/icons/hotel.svg',
        Close_by_district: '/assets/images/icons/close_by.svg',
        Airport: '/assets/images/icons/airport.svg',
        // Restaurants: '/assets/images/icons/restaurant.svg',
        // Sport: '/assets/images/icons/sport.svg',
        Mosque: '/assets/images/icons/mosque.svg',
        // Way_To_Asia: '/assets/images/icons/way_to_asia.svg',
        // Exhibition_Center: '/assets/images/icons/exhivis.svg',
        // Major: '/assets/images/icons/major.svg',
    };

    async function fetchExteriorImage() {
        //setExteriorImage(true);
        try {
            const res = await axios.get("assets/data/locationData.json");
            if (res.data) {
                setLocationData(res.data);
            }
        } catch (error) {
            setLocationData(false);
        }
    }

    useEffect(() => {
        fetchExteriorImage();
    }, [])

    const onClikcHide = () => {
        setMarkerShow(false);
        setDirections(null)
        setInfoWindowContent('')
        setInfoWindowPosition(null)
        setSelectedCategory(null)
        setCatogoryImage('');
        setLocationCatogory('');
        setCatogoryAddress('');
        setCatogoryDistance('');
        setCatogoryTime('')
        setCatogoryName('');
        setShowAllActive(false); // Set the button as inactive
        setHideAllActive(true); // Set the other button as active
    }
    const onLoad = map => {
        setMap(map);
    };

    const onUnmount = map => {
        setMap(null);
    };

    const handleCategoryClick = category => {
        setSelectedCategory(category);
        setSelectedMarker(null);
        setDirections(null);
        setInfoWindowContent('')
        setInfoWindowPosition(null)
        setMarkerShow(true);
        setIsActive(true)
        setCatogoryImage('');
        setLocationCatogory('');
        setCatogoryAddress('');
        setCatogoryDistance('');
        setCatogoryTime('')
        setCatogoryName('');
        setShowAllActive(false);
        setHideAllActive(false);
        setFilteredCategory(category); // Set the selected category
        setShowAllMarkers(false); // Set the flag to show only specific markers
    };
    const handleMarkerClick = marker => {
        setSelectedMarker(marker);
        setInfoWindowPosition(marker.position);

        // Calculate directions from initialCenter to the clicked marker
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: initialCenter,
                destination: marker.position,
                travelMode: 'DRIVING',
            },
            (response, status) => {
                if (status === 'OK') {
                    setDirections(response);
                    const distance = response.routes[0].legs[0].distance.text;
                    const time = response.routes[0].legs[0].duration.text;
                    const markerName = marker.label; // Get the name of the marker
                    const markerAddress = marker.address; // Get the name of the marker
                    const markerImage = marker.image_name; // Get the name of the marker
                    setCatogoryImage(markerImage);
                    setLocationCatogory(markerName);
                    setCatogoryAddress(markerAddress);
                    setCatogoryDistance(distance);
                    setCatogoryTime(time)
                    setCatogoryName(marker.category);

                    // Set the selected category based on the marker's category
                    setSelectedCategory(marker.category);

                    const infoWindowContent = `
                        <div><strong>${markerName}</strong></div>
                        <div>${distance}</div>
                    `;
                    setInfoWindowContent(infoWindowContent);
                } else {
                    console.error('Directions request failed');
                    setDirections(null);
                }
            }
        );
    };
    const onclickShowAll = () => {
        setMarkerShow(true); // Ensure the markerShow state is set to true
        setShowAllMarkers(true); // Set the flag to show all markers
        setSelectedCategory(null); // Clear the selected category
        setShowAllActive(true);
        setHideAllActive(false);
    }
    const modifiedLocationData = locationData.map(location => {
        // Regular expression to remove street and house numbers (e.g., "123 Main St, Apt 456" -> "Main St, Apt")
        const modifiedAddress = location.address.replace(/^\d+\s+[^,]+/, '');

        return {
            ...location,
            address: modifiedAddress,
        };
    });

    const onClickBoxOpen = () => {
        filterPannel ? setFilterPannel(false) : setFilterPannel(true)
    }
    return isLoaded ? (
        <div>
            <div className={!filterPannel ? 'google_map_list' : "google_map_list1"}>
                <div className='google_map_list_Data'>
                    <div className='arrowBtn' onClick={onClickBoxOpen}>
                        {
                            !filterPannel ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" className="bi bi-arrow-right-square-fill" viewBox="0 0 16 16">
                                    <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z" />
                                </svg>
                                :
                                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="#fff" className="bi bi-arrow-left-square-fill" viewBox="0 0 16 16">
                                    <path d="M16 14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12zm-4.5-6.5H5.707l2.147-2.146a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L5.707 8.5H11.5a.5.5 0 0 0 0-1z" />
                                </svg>
                        }
                    </div>
                    <div className={!filterPannel ? 'google_map_list_items' : "google_map_list_items1"}>
                        <h3>Location</h3>
                        {/* <h4>Alya Konutları</h4> */}
                        <div className='locationBtn'>
                            <button onClick={onclickShowAll} className={showAllActive ? 'active-button' : ''}>
                                Show All <p></p>
                            </button>
                            <button onClick={onClikcHide} className={hideAllActive ? 'active-button' : ''}>
                                Hide All<p></p>
                            </button>
                        </div>
                        <div className='locationList'>
                            <ul className=''>
                                {['Education', 'Hospital', 'Club', 'Mall', 'Hotel', 'Close_by_district', 'Airport', 'Mosque'].map((category) => {
                                    let bId = "new_bedid_";
                                    return (
                                        <li
                                            className={`surroundingItems ${bId + category} ${selectedCategory === category ? 'active' : ''}`}
                                            key={category}
                                            onClick={() => handleCategoryClick(category)}
                                            style={{ cursor: 'pointer', fontWeight: selectedCategory === category ? 'bold' : 'normal' }}
                                        >
                                            {category.replaceAll("_", " ")}
                                        </li>
                                    )
                                })}
                            </ul>
                            {
                                infoWindowPosition && locationCatogory && catogoryName && catogoryAddress && catogoryDistance && catogoryTime && (
                                    <div className='surroundingData'>
                                        <p style={{ borderBottom: "5px solid #8dc87e", textTransform: "uppercase", marginBottom: "15px" }}>{locationCatogory}</p>
                                        <p>Category : {catogoryName}</p>
                                        <p>Address : {catogoryAddress}</p>
                                        <p>Distance : {catogoryDistance}</p>
                                        <p>Time : {catogoryTime}</p>
                                        <img src={`/assets/images/icons/images/${selectedCategory && locationData.find(item => item.image_name === selectedCategory) || `${catogoryImage}.jpg`}`} className='img-fluid' />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            {isLoaded && (
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={initialCenter}
                    zoom={11}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                    options={{
                        // mapTypeId: 'terrain',
                        // mapTypeId: 'satellite', // Set map type to satellite
                        styles: [
                            {
                                featureType: 'poi',
                                elementType: 'labels',
                                stylers: [{ visibility: 'off' }]
                            },
                            {
                                featureType: 'road',
                                elementType: 'labels',
                                stylers: [{ visibility: 'on' }]
                            },
                            {
                                featureType: 'road',
                                elementType: 'labels',
                                stylers: [{ visibility: 'on' }]
                            },
                            {
                                featureType: 'road.highway',
                                elementType: 'labels',
                                stylers: [{ visibility: 'on' }]
                            },
                            {
                                featureType: 'transit',
                                elementType: 'labels',
                                stylers: [{ visibility: 'off' }]
                            },
                            {
                                featureType: 'administrative',
                                elementType: 'labels',
                                stylers: [{ visibility: 'on' }]
                            },
                            {
                                featureType: 'road.local',
                                elementType: 'labels',
                                stylers: [{ visibility: 'off' }] // Hide local street labels
                            },
                        ],
                        // zoom: 15,
                    }}
                >
                    {/* Add a single marker at initialCenter */}
                    <Marker
                        position={initialCenter}
                        icon={{
                            url: "/al_shafa.png",
                            scaledSize: new window.google.maps.Size(80, 120), // Adjust the size as needed
                        }}
                    />
                    {/* Display markers based on selected category */}
                    {markerShow &&
                        locationData.map((row) => {
                            // Check if we should show this marker based on the filters
                            const showMarker = showAllMarkers || filteredCategory === row.category;
                            return showMarker && (
                                <Marker
                                    key={row.id}
                                    position={row.position}
                                    onClick={() => handleMarkerClick(row)}
                                    icon={{
                                        url: categoryIcons[row.category],
                                        scaledSize: new window.google.maps.Size(30, 30),
                                    }}
                                />
                            );
                        })
                    }

                    {/* Display directions */}
                    {directions && (
                        <DirectionsRenderer
                            directions={directions}
                            options={{
                                polylineOptions: {
                                    strokeColor: 'blue',
                                    strokeOpacity: 0.7,
                                    strokeWeight: 5
                                }
                            }}
                        />
                    )}

                    {/* Display info window with name and distance */}
                    {infoWindowPosition && (
                        <InfoWindow
                            position={infoWindowPosition}
                            onCloseClick={() => setInfoWindowPosition(null)}
                        >
                            <div dangerouslySetInnerHTML={{ __html: infoWindowContent }} />
                        </InfoWindow>
                    )}
                </GoogleMap>
            )}
        </div>
    ) : (
        <></>
    );
}

export default React.memo(Surroundings);